import { useRouter } from 'next/router';
import { useState } from 'react';
import { getVideo } from './videoList';
import { VideoPlayer } from './VideoPlayer';
export const VideoFromQuery = () => {
  const router = useRouter();
  const [showVideo, setShowVideo] = useState(true);
  const videoType = router.query.v?.toString();
  if (!videoType) {
    return null;
  }
  const video = getVideo(videoType) ?? getVideo(videoType, 'id');
  if (!(video && showVideo)) {
    return null;
  }
  return <VideoPlayer hideVideo={() => setShowVideo(false)} id={video.id} playInline={false} data-sentry-element="VideoPlayer" data-sentry-component="VideoFromQuery" data-sentry-source-file="VideoFromQuery.tsx" />;
};